import {
  IcoSparkles,
  IcoBook,
  IcoChat,
  IcoVideoCamera,
  IcoCalendar,
  IcoAcademicCap,
  IcoUsers,
  IcoQuestion,
  IcoUser,
  IcoSettings,
} from '@components/icons';
import { useCurrentUser } from 'client/lib/auth';
import { hasLevel } from 'shared/auth';
import { MiraseeLogo } from '@course/components/mirasee-logo';
import { AIP_COURSE_ID } from 'shared/mirasee-consts';
import { CommunityNavLink } from '../../pages/mirasee-community/community-nav-link';
import { StudentTabs } from './props';

export function AipCourseNav({ currentLink }: { currentLink: StudentTabs }) {
  const user = useCurrentUser();
  const baseUrl = `/courses/${AIP_COURSE_ID}`;

  return (
    <div class="flex h-full min-h-0 flex-col w-64">
      <div class="pt-8 pb-4 px-6">
        <MiraseeLogo href="/community" />
      </div>
      <nav class="flex flex-1 flex-col p-4">
        <ul role="list" class="flex flex-1 flex-col gap-y-7">
          <li>
            <ul role="list" class="-mx-2 flex flex-col gap-1">
              <CommunityNavLink
                isSelected={currentLink === 'home'}
                href="/community"
                name="AI Playground"
                Icon={IcoSparkles}
              />
              <CommunityNavLink
                isSelected={currentLink === 'modules'}
                href={`${baseUrl}/lessons`}
                name="Resources"
                Icon={IcoBook}
              />
              <CommunityNavLink
                isSelected={currentLink === 'discussions'}
                href={`${baseUrl}/discussions/all`}
                name="Discussions"
                Icon={IcoChat}
              />
              <CommunityNavLink
                isSelected={currentLink === 'meetings'}
                href={`${baseUrl}/meetings`}
                name="Calls"
                Icon={IcoVideoCamera}
              />
              <CommunityNavLink
                isSelected={currentLink === 'calendar'}
                href={`${baseUrl}/calendar`}
                name="Calendar"
                Icon={IcoCalendar}
              />
              <CommunityNavLink
                isSelected={false}
                href="/community/courses"
                name="Courses"
                Icon={IcoAcademicCap}
              />
              <CommunityNavLink
                isSelected={false}
                href={`${baseUrl}/people`}
                name="People"
                Icon={IcoUsers}
              />
              <CommunityNavLink
                isSelected={false}
                href="/community/help"
                name="Help"
                Icon={IcoQuestion}
              />
            </ul>
          </li>
        </ul>
        <footer class="flex flex-col pt-4 pb-8 border-t border-primary w-full">
          <ul role="list" class="-mx-2 flex flex-col gap-1">
            <CommunityNavLink isSelected={false} href="/account" name="Account" Icon={IcoUser} />
            {hasLevel(user, 'admin') && (
              <CommunityNavLink
                isSelected={false}
                href="/admin/people"
                name="Manage Site"
                Icon={IcoSettings}
              />
            )}
          </ul>
        </footer>
      </nav>
    </div>
  );
}
